import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=d0364006&scoped=true&"
import script from "./Blank.vue?vue&type=script&lang=ts&"
export * from "./Blank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0364006",
  null
  
)

export default component.exports